import FilterableSelect from '@/components/inputs/FilterableSelect/FilterableSelect'
import NameValue from '@/types/NameValue'
import { useTranslation } from 'next-i18next'
import React from 'react'

type Props = {
  selectedYear: number | undefined
  onSelectedYear: (value: number) => void
}

const CarModelYears = (props: Props) => {
  const { t } = useTranslation('shop')

  const onSelectedYear = (value: string | null) => {
    props.onSelectedYear(Number(value))
  }

  // generate years from 1950 to current year using useMemo, order by current year first
  const years = React.useMemo(() => {
    const currentYear = new Date().getFullYear()
    const years: NameValue[] = []
    for (let i = currentYear; i >= 1950; i--) {
      years.push({
        name: `${i.toString()}`,
        value: i
      })
    }
    return years
  }, [])

  return (
    <FilterableSelect
      options={years || []}
      name="years"
      placeholder={t('carModelYear') || ''}
      value={props.selectedYear ? props.selectedYear.toString() : null}
      onChange={onSelectedYear}
      enableFiltering={false}
    />
  )
}

export default CarModelYears